export default {
  '***': {
    '***': {
      '***': {
        displayFilters: null,
        staticFilters: [
          {
            label: 'Age',
            code: 'age',
            multi: true,
            options: [
              {
                label: '18-34',
                value: 1,
                selected: false
              },
              {
                label: '35-49',
                value: 2,
                selected: false
              },
              {
                label: '50-65',
                value: 3,
                selected: false
              }
            ]
          },
          {
            label: 'Gender',
            code: 'gender',
            multi: true,
            options: [
              {
                label: 'Male',
                value: 1,
                selected: false
              },
              {
                label: 'Female',
                value: 2,
                selected: false
              },
              {
                label: 'Other',
                value: 3,
                selected: false
              }
            ]
          },
          {
            label: 'HHI',
            // excludeFromVerbatims: true,
            code: 'hhi',
            multi: true,
            options: [
              {
                label: 'Under $40K',
                value: 1,
                selected: false
              },
              {
                label: '$40K - $74K',
                value: 2,
                selected: false
              },
              {
                label: '$75K+',
                value: 3,
                selected: false
              }
            ]
          },
          {
            label: 'Primary Ethnicity',
            code: 'primary_ethnicity',
            multi: true,
            options: [
              {
                label: 'Asian/Pacific Islander',
                value: 1,
                selected: false
              },
              {
                label: 'Black/African American',
                value: 2,
                selected: false
              },
              {
                label: 'Hispanic/Latino/Spanish',
                value: 3,
                selected: false
              },
              {
                label: 'White/Caucasian',
                value: 4,
                selected: false
              },
              {
                label: 'Other',
                value: 5,
                selected: false
              }
            ]
          },
          {
            label: 'TMU Customers',
            code: 'tmu_customers',
            multi: true,
            options: [
              {
                label: 'Customer',
                value: 1,
                selected: false
              },
              {
                label: 'Prospect',
                value: 2,
                selected: false
              }
            ]
          }
        ]
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/config/components/scorecard/ScorecardView/ScorecardFilter/index.js